const PUBLIC_FORMS_BASE = String(
  process.env.REACT_APP_PUBLIC_FORMS_URL || 'https://si3.space'
).replace(/\/+$/, '');

export function getPublicSiteBase() {
  return PUBLIC_FORMS_BASE;
}

const OVERLAY_PUBLIC_PATHS = {
  'grow3dge-inquiry': '/grow3dge#programinquiry',
  'wellbeing-inquiry': '/wellbeing#inquiry',
  'dao-application': '/dao#application',
  'dao-waitlist': '/dao-waitlist',
  'siherdefi-application': '/siher#defi-application',
  'si-her-defi-application': '/siher#defi-application',
  'defi-application': '/siher#defi-application'
};

/**
 * Referral share links land on the section of the page (scroll anchor)
 * rather than opening the form overlay immediately.
 * The ?ref= code is preserved so the form auto-fills when the user clicks Apply.
 */
const REFERRAL_LANDING_PATHS = {
  'siherdefi-application': '/siher#siherdefi',
  'si-her-defi-application': '/siher#siherdefi',
  'defi-application': '/siher#siherdefi',
  'dao-waitlist': '/dao-waitlist',
  'dao-application': '/dao-waitlist'
};

/** Public form hosted on si3.space. Overlay forms use the parent page + hash. */
export function formPublicUrl(slug) {
  const clean = String(slug || '').trim().replace(/^\/+/, '');
  if (!clean) return '';
  const overlay = OVERLAY_PUBLIC_PATHS[clean];
  if (overlay) return `${PUBLIC_FORMS_BASE}${overlay}`;
  return `${PUBLIC_FORMS_BASE}/${clean}`;
}

export function referralShareUrl(slug, code) {
  const clean = String(slug || '').trim().replace(/^\/+/, '');
  const ref = String(code || '').trim().toUpperCase();
  if (!clean || !ref) return '';

  // Use the section-scroll path for referral links so recipients land
  // on the page with the DeFi section in view, not the form overlay.
  const landingPath = REFERRAL_LANDING_PATHS[clean];
  const base = landingPath
    ? `${PUBLIC_FORMS_BASE}${landingPath}`
    : formPublicUrl(clean);

  try {
    const url = new URL(base);
    url.searchParams.set('ref', ref);
    return url.toString();
  } catch {
    return `${base}?ref=${encodeURIComponent(ref)}`;
  }
}
